import { StreamingPlayerType } from '@heardis/stream-contracts';
import React from 'react';
import CompilationPlayer from '../CompilationPlayer/CompilationPlayer';
import LoadingScreen from '../PageLayout/LoadingScreen/LoadingScreen';
import RadioStationOnDemandPlayer from '../RadioStation/RadioStationOnDemandPlayer';

interface StreamingPlayerProps {
  children: React.ReactNode;
  type: StreamingPlayerType;
  autoplay: boolean;
}

function StreamingPlayer({ children, type, autoplay }: StreamingPlayerProps): JSX.Element {
  switch (type) {
    case StreamingPlayerType.RADIO_STATION:
      return <RadioStationOnDemandPlayer autoplay={autoplay}>{children}</RadioStationOnDemandPlayer>;
    case StreamingPlayerType.COMPILATION:
      return <CompilationPlayer autoplay={autoplay}>{children}</CompilationPlayer>;
    default:
      return <LoadingScreen message="Unsupported streaming player type" />;
  }
}

export default StreamingPlayer;
